// @ts-nocheck

import React, { useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Redirect } from 'react-router-dom';

import { externalLinkOpen } from '../../../actions/externallink';
import { getRedirectUrl, RedirectServices } from '../../../config/urls';
import useMergeProps from '../../../hooks/useMergeProps';
import RoutesRedirectionFactory from '../../../utils/routes/RoutesRedirectionFactory';
import { restartKLAdventure } from '../actions/kl';
import { openKLView } from '../actions/routes';
import KLEnrollment from '../components/KLEnrollment';
import { selectIsKLEnabled } from '../selectors/runtime';
import selectKLEnrollementProps from '../selectors/specifics/selectKLEnrollementProps';
import { KLUserStatuses } from '../types/user';

type KLEnrollmentContainerProps = {
  className?: string;
};

const KLEnrollmentContainer = (ownProps: KLEnrollmentContainerProps) => {
  const dispatch = useDispatch();
  const KLUserStatus = useSelector((state) => state.kl.user?.status);

  const selectedProps = useSelector(selectKLEnrollementProps);

  const onEnroll = useCallback(() => {
    dispatch(restartKLAdventure());
    dispatch(openKLView());
  }, [dispatch]);

  const onVideoTutorialClick = useCallback(() => {
    dispatch(externalLinkOpen(getRedirectUrl(RedirectServices.KL_ENROLLMENT_VIDEO_TUTORIAL)));
  }, [dispatch]);

  const otherProps = useMemo(
    () => ({
      onEnroll,
      onVideoTutorialClick,
    }),
    [onEnroll, onVideoTutorialClick],
  );

  const enhancedProps = useMergeProps({ ownProps, selectedProps, otherProps });

  const isKLEnabled = useSelector(selectIsKLEnabled);

  if (isKLEnabled) {
    if (KLUserStatus && KLUserStatus !== KLUserStatuses.OFF) {
      return <Redirect to={RoutesRedirectionFactory.getKLRoutePathname()} />;
    }

    return <KLEnrollment {...enhancedProps} />;
  }

  return <Redirect to={RoutesRedirectionFactory.getHomeRoutePathname()} />;
};

export default KLEnrollmentContainer;
